import { htmlToText } from "html-to-text";

export function transformHtmlToText(html: string): string {
	return htmlToText(html, {
		selectors: [
			{ selector: "a", format: "skip" },
			{ selector: "img", format: "skip" },
		],
	}).replace(/&nbsp;|\n/gu, " ");
}
